import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "mmi-preview" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger py-2 mb-3"
}
const _hoisted_3 = { class: "mb-0 mt-2 small" }
const _hoisted_4 = {
  key: 1,
  class: "alert alert-warning py-2 mb-3 small"
}
const _hoisted_5 = { class: "d-flex align-items-end gap-2 flex-wrap mb-3" }
const _hoisted_6 = { class: "nav nav-tabs flex-grow-1 mb-0" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 2,
  class: "alert alert-warning py-1 px-2 small"
}
const _hoisted_9 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = {
  class: "form-check-label small",
  for: "mmi-only-changed"
}
const _hoisted_12 = { class: "text-muted small ms-auto" }
const _hoisted_13 = { class: "table-responsive mmi-scroll" }
const _hoisted_14 = { class: "table table-sm table-hover align-middle mb-0" }
const _hoisted_15 = { class: "text-muted small" }
const _hoisted_16 = {
  key: 0,
  class: "badge bg-info text-dark ms-1"
}
const _hoisted_17 = { class: "small text-muted" }
const _hoisted_18 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DraftTreeView = _resolveComponent("DraftTreeView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.draft.unplaceable?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.draft.unplaceable.length) + " sin colocar", 1),
          _cache[2] || (_cache[2] = _createTextVNode(" — sin fecha de CMMI no hay orden de replay (D10). Reportados, nunca adivinados. ", -1)),
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.unplaceable, (u) => {
              return (_openBlock(), _createElementBlock("li", {
                key: u.username
              }, [
                _createElementVNode("code", null, _toDisplayString(u.username), 1),
                _createTextVNode(" — " + _toDisplayString(u.reason), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.draft.warnings?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.warnings, (w, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(w), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "alert alert-info py-2 small" }, [
      _createElementVNode("i", { class: "fas fa-circle-info" }),
      _createTextVNode(" Los "),
      _createElementVNode("code", null, "isPassUp"),
      _createTextVNode(" se editan por "),
      _createElementVNode("strong", null, "SWAP entre hermanos"),
      _createTextVNode(". Un flip suelto cambia la economía del pase (§21.2). ")
    ], -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tab.key,
            class: "nav-item"
          }, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["nav-link", { active: _ctx.view === tab.key }]),
              onClick: ($event: any) => (_ctx.view = tab.key)
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas", tab.icon])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(tab.label), 1)
            ], 10, _hoisted_7)
          ]))
        }), 128))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-outline-primary mb-1",
        title: "Descarga el árbol del CMMI completo en un fichero HTML que se puede mandar y abrir en cualquier navegador",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportHtml && _ctx.exportHtml(...args)))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("i", { class: "fas fa-file-arrow-down" }, null, -1),
        _createTextVNode(" Exportar para compartir ", -1)
      ]))])
    ]),
    (_ctx.exportError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
          _createTextVNode(" No se pudo generar el fichero: " + _toDisplayString(_ctx.exportError), 1)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_DraftTreeView, { forest: _ctx.forest }, null, 8, ["forest"]), [
      [_vShow, _ctx.view === 'tree']
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            id: "mmi-only-changed",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.onlyChanged) = $event)),
            class: "form-check-input",
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.onlyChanged]
          ]),
          _createElementVNode("label", _hoisted_11, " Sólo los que cambian (" + _toDisplayString(_ctx.changedCount) + ") ", 1)
        ]),
        _createElementVNode("span", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.rows.length) + " de " + _toDisplayString(_ctx.draft.nodes.length) + " nodos · capítulo ", 1),
          _createElementVNode("code", null, _toDisplayString(_ctx.draft.chapter), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("table", _hoisted_14, [
          _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "table-light sticky-top" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { style: {"width":"3rem"} }, "#"),
              _createElementVNode("th", null, "Usuario"),
              _createElementVNode("th", null, "Padre (nuevo)"),
              _createElementVNode("th", null, "Padre (viejo)"),
              _createElementVNode("th", null, "pass-up nuevo"),
              _createElementVNode("th", null, "pass-up viejo"),
              _createElementVNode("th", null, "Fecha CMMI")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (n) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: n.username,
                class: _normalizeClass({ 'table-warning': _ctx.changed(n) })
              }, [
                _createElementVNode("td", _hoisted_15, _toDisplayString(n.order), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("strong", null, _toDisplayString(n.username), 1),
                  (n.isGenesis)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "génesis"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("code", null, _toDisplayString(n.parentPK), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("code", {
                    class: _normalizeClass(["text-muted", {
                    'text-danger fw-bold': n.legacyParent !== n.parentPK,
                  }])
                  }, _toDisplayString(n.legacyParent ?? "—"), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", n.isPassUp ? 'bg-dark' : 'bg-light text-dark border'])
                  }, _toDisplayString(n.isPassUp ? "sí" : "no"), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", 
                    n.legacyIsPassUp == null
                      ? 'bg-light text-muted border'
                      : n.legacyIsPassUp !== n.isPassUp
                      ? 'bg-danger'
                      : 'bg-light text-dark border'
                  ])
                  }, _toDisplayString(n.legacyIsPassUp == null
                      ? "—"
                      : n.legacyIsPassUp
                      ? "sí"
                      : "no"), 3)
                ]),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.date(n.cmmiDateMs)), 1)
              ], 2))
            }), 128)),
            (_ctx.rows.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("td", {
                    colspan: "7",
                    class: "text-center text-muted py-3"
                  }, " Nada cambia respecto al legacy. ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.view === 'table']
    ])
  ]))
}